"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  EnvConfig: () => EnvConfig
});
module.exports = __toCommonJS(index_exports);
var EnvConfig = {
  API_URL: process.env.GATSBY_KTO_API,
  SITE_URL: process.env.GATSBY_KTO_URL,
  ORYX_LAUNCH_URL: process.env.GATSBY_KTO_ORYX_LAUNCH_URL,
  RELAX_LAUNCH_URL: process.env.GATSBY_KTO_RELAX_LAUNCH_URL,
  SMART_SOFT_URL: process.env.GATSBY_KTO_SMART_SOFT_URL,
  PLAY_TECH_URL: process.env.GATSBY_KTO_PLAY_TECH_URL,
  PLAY_TECH_INSTANCE: process.env.GATSBY_KTO_PLAY_TECH_INSTANCE,
  CMS_API_URL: process.env.WORDPRESS_API_URL,
  TEMPORARY_CMS_API_URL: process.env.TEMPORARY_WORDPRESS_API_URL,
  CMS_URL: process.env.GATSBY_WORDPRESS_URL,
  SPORTS_WALLET_CODE: process.env.GATSBY_SPORTS_WALLET_CODE,
  GATSBY_GTM_CODE: process.env.GATSBY_GTM_CODE,
  GATSBY_SPORTS_URL: process.env.GATSBY_SPORTS_URL,
  GATSBY_SPORTS_URL_V2: process.env.GATSBY_SPORTS_URL_V2,
  GATSBY_ARETONET_ID: process.env.GATSBY_ARETONET_ID,
  GATSBY_TEADS_PIXEL_ID: process.env.GATSBY_TEADS_PIXEL_ID,
  MOCKED_LAUNCH_URL: process.env.GATSBY_KTO_MOCKED_LAUNCH_URL,
  RELAX_PARTNER_ID: process.env.GATSBY_KTO_RELAX_PARTNER_ID,
  GATSBY_GIST_ID: process.env.GATSBY_GIST_ID,
  GATSBY_RECAPTCHA_KEY: process.env.GATSBY_RECAPTCHA_KEY,
  GATSBY_MY_AFF_BRANDED: process.env.GATSBY_MY_AFF_BRANDED,
  GATSBY_MY_AFF_ORGANIC: process.env.GATSBY_MY_AFF_ORGANIC,
  GATSBY_KTO_RELAX_PARTNER: process.env.GATSBY_KTO_RELAX_PARTNER,
  GATSBY_KTO_SMART_SOFT_PORTAL_NAME: process.env.GATSBY_KTO_SMART_SOFT_PORTAL_NAME,
  GATSBY_SUPPORT_EMAIL: process.env.GATSBY_SUPPORT_EMAIL,
  GATSBY_GTM_DOMAIN: process.env.GATSBY_GTM_DOMAIN,
  GATSBY_REFER_A_FRIEND_BANNER: process.env.GATSBY_REFER_A_FRIEND_BANNER,
  GATSBY_THEME_COLORS_PRIMARY: process.env.GATSBY_THEME_COLORS_PRIMARY,
  GATSBY_THEME_COLORS_PRIMARY_CONTRAST: process.env.GATSBY_THEME_COLORS_PRIMARY_CONTRAST,
  GATSBY_THEME_COLORS_SECONDARY: process.env.GATSBY_THEME_COLORS_SECONDARY,
  GATSBY_THEME_COLORS_TERTIARY: process.env.GATSBY_THEME_COLORS_TERTIARY,
  GATSBY_LIVEAGENT_SRC: process.env.GATSBY_LIVEAGENT_SRC,
  GATSBY_LIVEAGENT_ID: process.env.GATSBY_LIVEAGENT_ID,
  GATSBY_LIVEAGENT_GROUP: process.env.GATSBY_LIVEAGENT_GROUP,
  GATSBY_THEME_LOGO_SIZE_MOBILE: process.env.GATSBY_THEME_LOGO_SIZE_MOBILE,
  GATSBY_THEME_LOGO_SIZE_DESKTOP: process.env.GATSBY_THEME_LOGO_SIZE_DESKTOP,
  GATSBY_COOKIE_PREFIX: process.env.GATSBY_COOKIE_PREFIX,
  GATSBY_UBOS_URL: process.env.GATSBY_UBOS_URL,
  GATSBY_GROWTHBOOK_URL: process.env.GATSBY_GROWTHBOOK_URL,
  GATSBY_GROWTHBOOK_KEY: process.env.GATSBY_GROWTHBOOK_KEY,
  GATSBY_CLOUDFARE_CAPTCHA_SITEKEY: process.env.GATSBY_CLOUDFARE_CAPTCHA_SITEKEY,
  GATSBY_CLOUDFARE_INVISIBLE_CAPTCHA_SITEKEY: process.env.GATSBY_CLOUDFARE_INVISIBLE_CAPTCHA_SITEKEY,
  GATSBY_CLOUDFLARE_TURNSTILE_SRC: process.env.GATSBY_CLOUDFLARE_TURNSTILE_SRC,
  GATSBY_SMARTICO_LABEL_KEY: process.env.GATSBY_SMARTICO_LABEL_KEY,
  GATSBY_SMARTICO_BRAND_KEY: process.env.GATSBY_SMARTICO_BRAND_KEY,
  GATSBY_SMARTICO_SCRIPT_URL: process.env.GATSBY_SMARTICO_SCRIPT_URL,
  GATSBY_SEO_CONTENT_STATUS: process.env.GATSBY_SEO_CONTENT_STATUS,
  GATSBY_KAMBI_BOOTSTRAP: process.env.GATSBY_KAMBI_BOOTSTRAP,
  GATSBY_KAMBI_WIDGET_API: process.env.GATSBY_KAMBI_WIDGET_API,
  GATSBY_KAMBI_ENV: process.env.GATSBY_KAMBI_ENV,
  GATSBY_KAMBI_OFFERING: process.env.GATSBY_KAMBI_OFFERING,
  GATSBY_KAMBI_AUTH_API: process.env.GATSBY_KAMBI_AUTH_API,
  GATSBY_ENV: process.env.GATSBY_ENV,
  GATSBY_INTL_LOCALE: process.env.GATSBY_INTL_LOCALE,
  GATSBY_RADAR_KEY: process.env.GATSBY_RADAR_KEY,
  GATSBY_GA_COOKIE: process.env.GATSBY_GA_COOKIE,
  GATSBY_GOOGLE_SSO_CLIENT_ID: process.env.GATSBY_GOOGLE_SSO_CLIENT_ID,
  GATSBY_LANGUAGES: process.env.GATSBY_LANGUAGES,
  GATSBY_USE_LOCALE_PATH_PREFIX: process.env.GATSBY_USE_LOCALE_PATH_PREFIX,
  GATSBY_USE_APP_PATH_PREFIX: process.env.GATSBY_USE_APP_PATH_PREFIX,
  GATSBY_KTO_URL: process.env.GATSBY_KTO_URL,
  GATSBY_AFFISE_TRACKING_URL: process.env.GATSBY_AFFISE_TRACKING_URL,
  GATSBY_AFFISE_CLIENT_ID: process.env.GATSBY_AFFISE_CLIENT_ID,
  OPEN_BETS_POLLING_INTERVAL: Number(process.env.GATSBY_OPEN_BETS_POLLING_INTERVAL) || 3e4
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  EnvConfig
});
